import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// /admin/ehi-journal більше не окрема сторінка (2026-09-22): журнал EHI ("Узагальнені", "Знімки") злито з
// калькулятором на /admin/health-index. Старий шлях лишено редіректом, щоб закладки й посилання не ламались;
// ?tab= (summaries/snapshots) переноситься як є - ті самі значення вкладок на новій сторінці.
export const AdminEhiJournalRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  return <Navigate to={`/admin/health-index${tab ? `?tab=${encodeURIComponent(tab)}` : ''}`} replace />;
};
